var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDashBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92195 11.9692C7.33195 11.9692 8.46195 13.1102 8.46195 14.5302V17.9392C8.46195 19.3492 7.33195 20.4992 5.92195 20.4992H2.54195C1.14195 20.4992 0.00195312 19.3492 0.00195312 17.9392V14.5302C0.00195312 13.1102 1.14195 11.9692 2.54195 11.9692H5.92195ZM17.4621 11.9692C18.8621 11.9692 20.0021 13.1102 20.0021 14.5302V17.9392C20.0021 19.3492 18.8621 20.4992 17.4621 20.4992H14.0821C12.6721 20.4992 11.5421 19.3492 11.5421 17.9392V14.5302C11.5421 13.1102 12.6721 11.9692 14.0821 11.9692H17.4621ZM5.92195 0.499512C7.33195 0.499512 8.46195 1.64951 8.46195 3.06051V6.46951C8.46195 7.88951 7.33195 9.02951 5.92195 9.02951H2.54195C1.14195 9.02951 0.00195312 7.88951 0.00195312 6.46951V3.06051C0.00195312 1.64951 1.14195 0.499512 2.54195 0.499512H5.92195ZM17.4621 0.499512C18.8621 0.499512 20.0021 1.64951 20.0021 3.06051V6.46951C20.0021 7.88951 18.8621 9.02951 17.4621 9.02951H14.0821C12.6721 9.02951 11.5421 7.88951 11.5421 6.46951V3.06051C11.5421 1.64951 12.6721 0.499512 14.0821 0.499512H17.4621Z",
    fill: "#5D7285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDashBoard);
export default __webpack_public_path__ + "static/media/home_dash_board.7f1dfbb2631f712e0c9a4b7d8a0f7969.svg";
export { ForwardRef as ReactComponent };